import { supabase } from './supabase';

export interface StreamEmbed {
  id: string;
  name: string;
  embed_url: string;
  display_order: number | null;
  active: boolean | null;
  created_at: string | null;
  updated_at: string | null;
}

export const streamEmbedsService = {
  // Obtener todos los embeds activos ordenados por display_order
  async getActive(): Promise<StreamEmbed[]> {
    const { data, error } = await supabase
      .from('stream_embeds')
      .select('*')
      .eq('active', true)
      .order('display_order', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  // Obtener todos los embeds (admin)
  async getAll(): Promise<StreamEmbed[]> {
    const { data, error } = await supabase
      .from('stream_embeds')
      .select('*')
      .order('display_order', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  // Crear un nuevo embed
  async create(embed: Pick<StreamEmbed, 'name' | 'embed_url' | 'display_order' | 'active'>): Promise<StreamEmbed> {
    const { data, error } = await supabase
      .from('stream_embeds')
      .insert(embed)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Actualizar un embed
  async update(id: string, embed: Partial<Pick<StreamEmbed, 'name' | 'embed_url' | 'display_order' | 'active'>>): Promise<StreamEmbed> {
    const { data, error } = await supabase
      .from('stream_embeds')
      .update({ ...embed, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Activar/Desactivar un embed
  async toggleActive(id: string, active: boolean): Promise<StreamEmbed> {
    const { data, error } = await supabase
      .from('stream_embeds')
      .update({ active, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Eliminar un embed
  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('stream_embeds')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },
};
